










































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AxiosData } from "@/common/http/http";
import { Util, getExcelJSONDataByList,getPageAPIs } from "@/common/util";
import { DeepLoop } from "@/common/deepLoop/deepLoop";
import {IdolAbnormalGoodsOrderDetailAPI} from "@/common/api/userManage/idolAbnormalGoodsOrderDetail";

import { CommonApi } from "@/common/api/common";

import gallery from "@/components/gallery.vue";

// import ZlSelect from "@/components/third-custom-components/select";

// import ZlOption from "@/components/third-custom-components/option";


import { excuteDownloadExport2Excel } from "@/common/xlsx";
export const pageApiList = getPageAPIs(IdolAbnormalGoodsOrderDetailAPI);

import {
  idolSaleMachineType2Ch,
  idolSaleMachineAbnormalStatus2Ch,
  idolAbnormalGOResStatusType2Ch,
  shareConfirmOptions,
  // transferUserLevel2ch,
  // leagueLevelName2Text,
} from '@/common/config'


@Component({
  filters: {
    showMaChineTypeName(device_type: number) {
      return idolSaleMachineType2Ch[device_type] || '未知'
    },
    showResStatusName(status: number) {
      return idolAbnormalGOResStatusType2Ch[status]
    },
    showAbnormalOrderTypeName(excepts: number[]) {
      if (!Array.isArray(excepts)) return ''
      return excepts.map((except: number) => idolSaleMachineAbnormalStatus2Ch[except]).join(';')
    }
  },
  components: {
    // ZlSelect,
    // ZlOption,
    gallery,
  },
})
export default class IdolAbnormalGoodsOrderDetail extends Vue {
  private abnormalGoodsOrderDetailApi: any;

  private deepLoopUtil: any;

  // private MIN_SCORE_NUM: number = MIN_SCORE_NUM

  // private MAX_SCORE_NUM: number = MAX_SCORE_NUM

  private utilIns: any;

  private get isShowResStatus() {
    const abnormalOrderDetail = this.abnormalOrderDetail

    const {
      status
    } = abnormalOrderDetail || {}

    return typeof status == 'number' && status > 0
  }



  // private debounceRefreshSingleCardInfoFunc: any

  private commonApi: any;
  constructor() {
    super();
    this.abnormalGoodsOrderDetailApi = new IdolAbnormalGoodsOrderDetailAPI();

    this.deepLoopUtil = new DeepLoop();

    this.commonApi = new CommonApi();

    // this.form = {
    //   ...this.deepLoopUtil.deepCopy(defaultForm),
    // };

    // this.forms = {
    //   ...this.deepLoopUtil.deepCopy(defaultForms, false),
    // }

    this.utilIns = new Util()

    // this.debounceRefreshSingleCardInfoFunc = this.utilIns.debounce.call(
    //   this,
    //   this.refreshSingleCardAccountInfo,
    //   800
    // )
  }

  private onJoinUserBlackList() {
    const abnormalOrderDetail = this.abnormalOrderDetail
    this.$prompt('确定停用该用户吗？', '', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      showInput: true,
      inputPlaceholder: '输入停用原因（选填）',
      beforeClose: (action, ins, done) => {
        const {
          inputValue = ''
        } = ins || {}

        switch (action) {
          case 'confirm':
            const params: any = {
              phone: abnormalOrderDetail.phone
            }

            if (inputValue) {
              params.reason = inputValue
            }
            this.abnormalGoodsOrderDetailApi.addSaleMachineBlackUser({
              ...params
            }, () => {
              this.getTable()
              done()
            }, () => {

            })
            break;
          case 'cancel':
          default:
            done();
        }
      }
    })
  }

  // 确认无须补款
  private noNeedPayMoreLoading: boolean = false
  private onNoNeedPayMore() {

    this.$confirm(`已确认此异常订单无需补款，确认后将从待处理列表中消失！`, "提示", {
      ...shareConfirmOptions,
    }).then(() => {
      this.noNeedPayMoreLoading = true
      this.abnormalGoodsOrderDetailApi.noNeedHandlePayMore({
        id: this.getGoodsOrderId
      }, () => {
        this.noNeedPayMoreLoading = false
        this.getTable()
      }, () => {
        this.noNeedPayMoreLoading = false
      })
    })
  }

  // 要发起补款订单
  private onGoNeedCreateMoreOrder() {
    const abnormalOrderDetail = this.abnormalOrderDetail

    const {
      device_id
    } = abnormalOrderDetail || {}

    this.$router.push({
      path: '/idolSupplementCreateGoodsOrder',
      query: {
        device_id,
        goods_order_id: this.getGoodsOrderId
      }
    })
  }


// 预览媒体文件
  private previewImages: any[] = [];
  private onPreviewMedia() {
    const abnormalVideoInfo = this.abnormalVideoInfo

    const getPreviewItem = (mode: string, url: string) => {
      switch (mode) {
      case "img":
        return {
          title: "",
          type: "image/jpeg",
          href: url,
          thumbnail: url,
        }
      case "video":
        return {
          title: "",
          type: "video/mp4",
          href: url,
          poster: `${url}?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast,ar_auto`,
        }
    }

    }

    const {
      previewVideos = []
    } = abnormalVideoInfo || {}

    const medias: any[] = previewVideos.map((previewUrl: string) => getPreviewItem('video', previewUrl));
    
    this.previewImages = medias;
  }
  // private handleClickChangePoint(btnItem: any, mode: string) {
  //   const form = this.form 
  //   // changeMode: add | sub | clear
  //   function changePointKeys(target: any, mode: string, changeMode: string, keys: string[], point: number = 0) {
  //     keys.forEach((key) => {
  //       const cur_point = target[mode][key]

  //       if (!isNaN(cur_point)) {
  //         target[mode][key] = Number(cur_point) 

  //         switch (changeMode) {
  //           case 'add':
  //             target[mode][key] += point
  //             break;
  //           case 'sub':
  //             target[mode][key] -= point
  //             break;
  //           case 'clear':
  //             target[mode][key] = 0
  //             break;
  //         }
  //       }
  //     })
  //   }

  //   switch (mode) {
  //     case 'left':
  //       changePointKeys(form, mode, 'add', ['single_max_score', 'score'], btnItem.value)

  //       changePointKeys(form, 'right', 'clear', ['single_max_score'])
  //       break;
  //     case 'right':
  //       changePointKeys(form, mode, 'add', ['single_max_score', 'score'], btnItem.value)

  //       changePointKeys(form, 'left', 'clear', ['single_max_score'])
  //       break;
  //   }

  //   this.form = form
  // }

  private form: any;

  private forms: any;

  private firstLoading: boolean = true;
  // private chooseTechnicianItem : any = null;

  // private tablePage: any = {
  //   totalCount: 0,
  //   pageNo: 1,
  //   pageSize: 10,
  //   pageSizes: [10, 20, 50, 100, 200, 500],
  // };

  private get getGoodsOrderId() {
    const {
      query = {}
    } = this.$route || {}

    const {
      goods_order_id = ''
    } = query

    return goods_order_id
  }


  private activated(): void {
    this.getTable();
  }

  private abnormalOrderDetail: any = {}

  private abnormalVideoInfo: any = {
    previewVideos: [],
    type: 1, // 类型 1视频
    url: ''
  }

  private getTable(): void {
    this.abnormalGoodsOrderDetailApi.getAbnormalOrderDetail(
      {
        id: this.getGoodsOrderId
      },
      (res: any) => {
        console.log(res, "res");
        // this.tableData = res.data;
        const { data: abnormalOrderDetail } = res;

        const {
          resource_info = {}
        } = abnormalOrderDetail || {}

        const {
          device_type,
          main_video = [],
          subsidiary_video = [],
          video_url = ''
        } = resource_info

        const abnormalVideoInfo = {
          type: device_type,
          previewVideos: [
            ...main_video,
            ...subsidiary_video
          ],
          url: video_url
        }
    
        this.abnormalOrderDetail = abnormalOrderDetail

        this.abnormalVideoInfo = abnormalVideoInfo
      

        this.firstLoading = false;
      },
      () => {
        this.firstLoading = false;
      },
      false
    );
  }


  // 后台返回的字段 转化为前端定义的字段
  private handleTableData(data: any): any {
    // const { gender } = data;
    const newData = {
      ...data,
      // device_name: orderDeviceType2ch[device],
      // pay_type_name: payType2ch[pay_type],
      // user_level_type_name: userLevel2ch[user_type],
      // gender_sex: transfromGenders[gender]
    };

    return newData;
  }


  private restForm(): void {
    // this.form = {
    //   ...this.deepLoopUtil.deepCopy(defaultForm),
    // };

    this.getTable();
  }

  private search(): void {
    // this.tablePage.pageNo = 1;
    // this.tableData = [];
    // this.tablePage.totalCount = 0;

    this.getTable();
  }

  private tableData: any[] = [];

  private handlePageChange(val: any) {
    // this.tablePage.pageNo = val.currentPage;
    // this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }
}
